import { Api } from "@relode/core";
import {
    MarketResearchCompensationResponse,
    MarketResearchDiversityResponse,
    MarketResearchSummaryResponse,
    MarketResearchSupplyDemandResponse,
} from "@relode/core/backend/marketResearch";

import { MarketResearchPublicOverviewResponse } from "./marketResearchPublicOverviewResponse";

export const marketResearchPublicService = {
    getOverview: async (token: string) => {
        const url = `/public/market-research?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "marketResearchPublicService.getOverview",
                data: { token },
            })
            .get<MarketResearchPublicOverviewResponse>();

        return response;
    },

    getCompensation: async (token: string) => {
        const url = `/public/market-research/compensation?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "marketResearchPublicService.getCompensation",
                data: { token },
            })
            .get<MarketResearchCompensationResponse>();

        return response;
    },

    getSupplyDemand: async (token: string) => {
        const url = `/public/market-research/supply-demand?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "marketResearchPublicService.getSupplyDemand",
                data: { token },
            })
            .get<MarketResearchSupplyDemandResponse>();

        return response;
    },

    getDiversity: async (token: string) => {
        const url = `/public/market-research/diversity?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "marketResearchPublicService.getDiversity",
                data: { token },
            })
            .get<MarketResearchDiversityResponse>();

        return response;
    },

    getSummary: async (token: string) => {
        const url = `/public/market-research/summary?token=${token}`;
        const response = await Api.url(url)
            .retries(3)
            .useSignal()
            .track({
                name: "marketResearchPublicService.getSummary",
                data: { token },
            })
            .get<MarketResearchSummaryResponse>();

        return response;
    },
};
